import { Injectable } from '@angular/core';
import { Base18Service, } from '@socrates/common';
import { II18NRepo } from './II18NRepo';

declare let window: any | undefined;

@Injectable()
export class I18NService extends Base18Service {

	constructor(private i18nRepo: II18NRepo) {
		super();
	}

	public static override getUsersLocale(defaultValue = 'en-US'): string {
		if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
			return defaultValue;
		}
		const browser = window.navigator as any;
		let lang = browser.languages ? browser.languages[0] : defaultValue;
		return lang || browser.language || browser.browserLanguage || browser.userLanguage || defaultValue;
	}

	public async loadMessages(langLocale: string | null = null): Promise<any> {
		if (!Base18Service.messages) {
			const locale = langLocale ?? I18NService.getUsersLocale();
			const tokens = await this.i18nRepo.loadTokens(locale);
			Base18Service.messages = tokens;
		}
		return Base18Service.messages;
	}
}
